// extracted by mini-css-extract-plugin
export default {"container":"SoYPqVfMmgzq_GdcDL83"};